const getEnvironment = () => {
    const hostname = window.location.hostname;
  
    if (hostname === 'admin.peiso.com.au') {
      return 'main';
    } else if (hostname === 'lucasrestaurants-admin.peiso.com.au') {
      return 'lucas';
    } else if (hostname === 'sandbox-admin.peiso.com.au') {
      return 'sandbox';
    }
    return 'sandbox';
  };
  
  /**
   * @type {Array<{NAME: string, API_BASE_URL: string}>}
   */
  const environments = {
    main: {
      NAME: 'main',
      BASE_URL: 'https://main.peiso.au',
    },
    lucas: {
      NAME: 'lucas',
      BASE_URL: '',
    },
    sandbox: {
      NAME: 'sandbox',
      BASE_URL: 'https://sandbox.peiso.dev',
    },
    local: {
      NAME: 'local',
      BASE_URL: 'http://localhost:8080',
    }
  };
  
  export const env = environments[getEnvironment()];
  


// WEBPACK FOOTER //
// ./src/env.js